document.addEventListener("DOMContentLoaded", () => {
  const slides = document.querySelectorAll(".slide-vs");

  function pauseAllVideos(exceptVideo = null) {
    document.querySelectorAll(".tiktok-video-vs").forEach((video) => {
      if (video !== exceptVideo) {
        video.pause();
        const slide = video.closest(".slide-vs");
        if (slide) {
          const playButton = slide.querySelector(".play-button-vs");
          const pauseButton = slide.querySelector(".pause-button-vs");
          if (playButton) playButton.style.display = "flex";
          if (pauseButton) {
            pauseButton.style.display = "none";
            pauseButton.classList.add("hidden-vs");
          }
        }
      }
    });
  }

  slides.forEach((slide) => {
    const playButton = slide.querySelector(".play-button-vs");
    const pauseButton = slide.querySelector(".pause-button-vs");
    const muteButton = slide.querySelector(".mute-button-vs");
    const video = slide.querySelector(".tiktok-video-vs");
    if (!video) return;

    let hidePauseButtonTimeout;

    function showPauseButton() {
      pauseButton.classList.remove("hidden-vs");
      clearTimeout(hidePauseButtonTimeout);
      hidePauseButtonTimeout = setTimeout(() => {
        if (!video.paused) {
          pauseButton.classList.add("hidden-vs");
        }
      }, 1200);
    }

    playButton.addEventListener("click", () => {
      pauseAllVideos(video);
      video.play();
    });

    pauseButton.addEventListener("click", () => {
      video.pause();
    });

    if (muteButton) {
      const iconMuted = muteButton.querySelector(".icon-muted-vs");
      const iconUnmuted = muteButton.querySelector(".icon-unmuted-vs");

      muteButton.addEventListener("click", (e) => {
        e.stopPropagation();
        video.muted = !video.muted;
        muteButton.setAttribute("data-muted", video.muted ? "true" : "false");
        muteButton.setAttribute(
          "aria-label",
          video.muted ? "Unmute video" : "Mute video"
        );
        if (iconMuted && iconUnmuted) {
          iconMuted.style.display = video.muted ? "block" : "none";
          iconUnmuted.style.display = video.muted ? "none" : "block";
        }
      });
    }

    video.addEventListener("play", () => {
      pauseAllVideos(video);
      playButton.style.display = "none";
      pauseButton.style.display = "flex";
      showPauseButton();
    });

    video.addEventListener("pause", () => {
      playButton.style.display = "flex";
      pauseButton.style.display = "none";
      pauseButton.classList.add("hidden-vs");
    });

    video.addEventListener("click", () => {
      if (video.paused) {
        pauseAllVideos(video);
        video.play();
      } else {
        showPauseButton();
      }
    });

    video.addEventListener("mousemove", showPauseButton);
    video.addEventListener("touchstart", showPauseButton, { passive: true });
  });

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (!entry.isIntersecting && !video.paused) {
          video.pause();
        }
      });
    },
    { threshold: 0.35 }
  );

  document.querySelectorAll(".tiktok-video-vs").forEach((video) => {
    observer.observe(video);
  });

  document.querySelectorAll(".slider-outer-vs").forEach((outer) => {
    const container = outer.querySelector(".slider-container-vs");
    const prevBtn = outer.querySelector(".slider-nav-prev-vs");
    const nextBtn = outer.querySelector(".slider-nav-next-vs");
    if (!container || !prevBtn || !nextBtn) return;

    function getScrollAmount() {
      const firstSlide = container.querySelector(".slide-vs");
      if (!firstSlide) return container.clientWidth;
      const style = window.getComputedStyle(firstSlide);
      const width = firstSlide.getBoundingClientRect().width;
      const gap = 10;
      return width + gap;
    }

    function updateNavState() {
      const maxScroll = container.scrollWidth - container.clientWidth - 1;
      prevBtn.disabled = container.scrollLeft <= 0;
      nextBtn.disabled = container.scrollLeft >= maxScroll;
    }

    prevBtn.addEventListener("click", () => {
      container.scrollBy({ left: -getScrollAmount(), behavior: "smooth" });
    });

    nextBtn.addEventListener("click", () => {
      container.scrollBy({ left: getScrollAmount(), behavior: "smooth" });
    });

    container.addEventListener("scroll", updateNavState, { passive: true });
    window.addEventListener("resize", updateNavState);
    updateNavState();
  });
});
